<script lang="ts">
  import Skin from "../assets/bo7-skin.webp";
  import Points from "../assets/cod-points.webp";
  import Emblem from "../assets/emblem_v2.webp";
  import Charm from "../assets/charm_v2.webp";
  import CallingCard from "../assets/calling_card_v2.webp";
  import ArrowDeliver from "../assets/arrow-deliver.svg";
  import { copy } from "../lib/stores/copy";
  import { languageStore } from "../lib/stores/language";
  import { isPrimaryCampaign } from "../lib/constants/countries";

  export let isRegister: boolean = false;
</script>

<div class="tabletLg:hidden w-[100vw] mb-[calc(118px+1rem)]" class:overflow-y-hidden={!isRegister}>
  <div class="flex justify-between tablet:justify-around pt-[14%]" class:overflow-y-hidden={!isRegister}>
    <div class="w-[60vw] max-w-[280px] mb-[-87%] ml-[-13%] tablet:ml-0">
      <div class="relative">
        <img src={Skin} alt="" class:mask-fade-75={isRegister}>
        <div class="absolute {$languageStore === 'en' ? 'left-[67%] top-[13%]' : 'left-[64%] top-[10%]'}">
          <div class="font-MrEavesXLSanNarOTUltra text-center leading-[1] whitespace-nowrap text-[11px] text-white font-black uppercase diffuse-text-shadow mobile:right-[10%]">
            {@html $copy.prizeNames.operatorSkinSplit}
          </div>
        </div>
      </div>
    </div>
    <div class="relative right-[16px] ml-[-20vw] tablet:ml-0">
      <div class="flex justify-end">
        <div class="text-center max-w-[140px] w-[28vw] mx-[4px] laptop:w-[11.5vw]">
          <div class="font-MrEavesXLSanNarOTUltra text-[11px] text-white font-black mb-[8px] uppercase diffuse-text-shadow">
            {$copy.prizeNames.emblem}
          </div>
          <img src={Emblem} alt="">
        </div>
        <div class="relative max-w-[140px] w-[20vw] mx-[4px] laptop:w-[11.5vw] mt-[-22%]">
          <div class="absolute top-[31%] left-[60%] translate-y-[-50%]">
            <div class="font-MrEavesXLSanNarOTUltra text-center text-[11px] text-white font-black uppercase diffuse-text-shadow leading-[1]">
              {$copy.prizeNames.charm}
            </div>
          </div>
          <img src={Charm} alt="">
        </div>
      </div>
      <div class="w-[54vw] max-w-[280px] ml-auto text-right mb-[16px] mt-[8px] mobileS:w-[60vw]">
        <div class="font-MrEavesXLSanNarOTUltra text-[11px] text-white font-black uppercase diffuse-text-shadow">
          {$copy.prizeNames.callingCard}
        </div>
        <img src={CallingCard} alt="">
      </div>
    </div>
  </div>
  {#if !isRegister}
    <div class="w-full px-[1rem] pb-[1.5rem] pt-0 mt-[-1.5px] z-20">
      <img src={ArrowDeliver} alt="" aria-hidden="true">
    </div>
  {/if}
  {#if isPrimaryCampaign}
  <div class="flex flex-col items-center">
    <div class="px-[1rem] flex items-center translate-y-[-25%]">
      <p class="font-MrEavesXLSanNarOTUltra text-[16px] text-white font-black mb-[12px] leading-[0.9] uppercase text-shadow mt-[10px] text-center mobileS:text-[21px]">
        <span class="font-LCScript text-primary capitalize leading-[0.75]">{@html $copy.prizeNames.plus}</span>
        {@html $copy.prizeNames.youCanWinSplit}
      </p>
    </div>
    <div class="flex flex-col px-[1rem] relative">
      <div class="w-[70vw]">
        <div class="font-MrEavesXLSanNarOTUltra absolute left-[14%] top-[2%] text-[11px] text-left diffuse-text-shadow text-white font-black uppercase mobileS:text-[12px] mobile:text-[15px]">
          {@html $copy.prizeNames.codPoints}
        </div>
        <img src={Points} alt="" class="relative z-[1]">
      </div>
    </div>
  </div>
  {/if}
</div>
